import { Map } from 'immutable';
import * as ParamsContext from './params_context';

const DEFAULT_STATE = new Map();

export function combineImmutableReducers(reducers, initialState = DEFAULT_STATE) {
  return (state, action) =>
    (state || initialState).withMutations(mutable => {
      Object.entries(reducers).forEach(([key, reducer]) => {
        mutable.set(key, reducer(mutable.get(key), action));
      });
    });
}

// Simply little helper that wraps setTimeout in a Promise
export const sleep = (duration, ...args) =>
  new Promise((resolve) =>
    setTimeout(() => resolve(...args), duration)
  );

// Toggle the data-state attribute of the first element identified by elemSelector
export function toggleState(elemSelector, one, two) {
  const elem = document.querySelector(elemSelector);
  elem.setAttribute('data-state', elem.getAttribute('data-state') === one ? two : one);
}

export const withParams = ParamsContext.withParams;
export const exportingParams = ParamsContext.exportingParams;



// WEBPACK FOOTER //
// ./src/util/index.js